import React, { useEffect, useMemo, useState } from 'react';
import { HexColorInput, RgbaStringColorPicker } from 'react-colorful';
import { colord } from 'colord';
import { hexToRgba } from '../../utils';

const SolidPicker = ({ value, onChange, activeGradientIndex }) => {
  const rgbaColor = useMemo(
    () =>
      value?.toString()?.startsWith('rgba')
        ? value
        : colord(value).toRgbString() || 'rgba(255, 255, 255, 1)',
    [value]
  );

  const percent = Math.floor(colord(rgbaColor).alpha() * 100);
  const [hexString, setHexString] = useState(
    colord(value)
      .alpha(+percent / 100)
      .toHex()
      .toUpperCase()
  );

  useEffect(() => {
    setHexString(
      colord(value)
        .alpha(+percent / 100)
        .toHex()
        .toUpperCase()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGradientIndex]);

  return (
    <div className="picker no-opacity">
      <div className="color-picker__content">
        <RgbaStringColorPicker
          color={rgbaColor}
          onChange={(val) => {
            setHexString(colord(val).toHex());
            onChange(val);
          }}
        />
      </div>
      <div className="color-picker__input">
        <HexColorInput
          className="color-picker__input--hex"
          prefixed
          color={hexString}
          onChange={(color) => {
            setHexString(color);
            onChange(hexToRgba(color, (+percent / 100).toString()));
          }}
        />
      </div>
    </div>
  );
};

export default SolidPicker;
